// extracted by mini-css-extract-plugin
export var caption = "style-module--caption--fb9f4";
export var captionContainer = "style-module--captionContainer--1b431";
export var carousel = "style-module--carousel--2c657";
export var carouselContainer = "style-module--carouselContainer--062de";
export var container = "style-module--container--e987b";
export var instagram = "style-module--instagram--0f84b";
export var item = "style-module--item--ec887";
export var itemContainer = "style-module--itemContainer--14244";
export var mediaContainer = "style-module--mediaContainer--7e272";